import React from 'react';
import { Form, Select, Row, Col } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';
import { t } from 'i18next';
import { DryerSectionContainer } from './DryerSection.styles';
import { EPButton } from '@/components';
import { DRYER_OPTIONS } from '../../RoomConfigurationContent.utils';
import { DryerType } from '@/store/SiteSurveyForm/constants';

interface DryerSectionProps {
  roomId: number;
  roomIndex: number;
  pressureType: string;
  dryers: Array<{
    id: string;
    dryerType: string;
  }>;
  onAddDryer: (roomId: number) => void;
  onRemoveDryer: (roomId: number, dryerId: string) => void;
}

const DryerSection: React.FC<DryerSectionProps> = observer(
  ({ roomId, roomIndex, pressureType, dryers, onAddDryer, onRemoveDryer }) => {
    return (
      <DryerSectionContainer>
        <Row style={{ width: '100%' }}>
          <Col xs={24} md={12}>
            <div className="dryer-section-title">{t('Dryers in the room')}</div>
          </Col>
          <Col xs={24} md={12} className="controls-container">
            {dryers?.length > 0 && (
              <>
                {dryers.map((dryer, index) => (
                  <Row key={dryer.id} className="dryer-row" justify="end" gutter={[0, 0]}>
                    <Col xs={{ flex: 1 }} md={{ flex: '0 0 15rem' }}>
                      <Form.Item
                        name={[pressureType, 'rooms', roomIndex, 'dryers', index, 'dryerType']}
                        className="dryer-form-item"
                      >
                        <Select
                          className="dryer-select"
                          value={dryer.dryerType}
                          disabled
                          size="large"
                          options={DRYER_OPTIONS}
                        />
                      </Form.Item>
                    </Col>
                    <Col className="button-col">
                      <EPButton
                        icon={<DeleteOutlined />}
                        size="large"
                        onClick={() => onRemoveDryer(roomId, dryer.id)}
                      />
                    </Col>
                  </Row>
                ))}
              </>
            )}

            <Row className="dryer-row" justify="end" gutter={[0, 0]}>
              <Col xs={{ flex: 1 }} md={{ flex: '0 0 15rem' }}>
                <Form.Item
                  name={[pressureType, 'rooms', roomIndex, 'newDryer', 'dryerType']}
                  className="dryer-form-item"
                  initialValue={DryerType.REFRIGERATED}
                >
                  <Select
                    className="dryer-select"
                    size="large"
                    options={DRYER_OPTIONS}
                    placeholder={t('Select Type')}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col className="button-col">
                <EPButton
                  icon={<PlusOutlined />}
                  size="large"
                  onClick={() => onAddDryer(roomId)}
                  title={t('Add another dryer')}
                  className="add-dryer-button"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </DryerSectionContainer>
    );
  },
);

export default DryerSection;
